<template>
  <div>
    <div class="navbar">
      <div class="top-nav row-between mt20">
        <img v-if="channelFlag" class="header-logo1" src="../../assets/images/yijia.png" alt="" @click="goHome" />
        <img class="header-logo2" :src="baseUrl + sysInfo[0].logo" alt="" @click="goHome" />
        <div class="search-box">
          <el-select class="custom-select" v-model="value" :placeholder="$t('Navbar.inputplac')" clearable filterable
            :style="{width: selectrem}" @change="changeSearch" :filter-method="filterData">
            <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="index">
            </el-option>
          </el-select>
        </div>
        <div v-if="!channelFlag" class="right-box row">
          <img class="mr10" src="../../assets/images/nav-phone.png" alt="" />
          <span :style="{ fontSize: spanrem}" style=" color: #20a3dd ; font-weight:700;">{{ sysInfo[0].phonenumber
          }}</span>
        </div>
      </div>
      <div class="row-between  mt20 mb20 nav-item">
        <el-tabs v-if="channelFlag" v-model="activeName" stretch @tab-click="handleClick">
          <el-tab-pane :label="$t('Navbar.home')" :name="$t('Navbar.home')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.parner')" :name="$t('Navbar.parner')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.vip')" :name="$t('Navbar.vip')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.activity')" :name="$t('Navbar.activity')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.form')" :name="$t('Navbar.form')"></el-tab-pane>
          <!-- <el-tab-pane label="健康管理" name="健康管理"></el-tab-pane>
          <el-tab-pane label="社区论坛" name="社区论坛"></el-tab-pane>
          <el-tab-pane label="机构入驻" name="机构入驻"></el-tab-pane> -->
        </el-tabs>
        <el-tabs v-else v-model="activeName" stretch @tab-click="handleClick">
          <el-tab-pane :label="$t('Navbar.home')" :name="$t('Navbar.home')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.parner')" :name="$t('Navbar.parner')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.health')" :name="$t('Navbar.health')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.community')" :name="$t('Navbar.community')"></el-tab-pane>
          <el-tab-pane :label="$t('Navbar.institution')" :name="$t('Navbar.institution')"></el-tab-pane>
          <!-- <el-tab-pane :label="$t('Navbar.vip')" :name="$t('Navbar.vip')"></el-tab-pane> -->
          <el-tab-pane :label="$t('Navbar.form')" :name="$t('Navbar.form')"></el-tab-pane>
          <!-- <el-tab-pane label="专业保险" name="专业保险"></el-tab-pane> -->
        </el-tabs>
        <div class="btn-box" style="display: flex;align-items: center;">
          <template v-if="isHaveToken()">
            <img class="cur-point" :class="{ 'active-btn': activeName === $t('Navbar.person') }"
              :src="activeName !== $t('Navbar.person') ? navUserIcon : navUserIconAct" alt="" @click="userView" />
            <img class="cur-point" :class="{ 'active-btn': activeName === $t('Navbar.cart') }" :src="
                activeName !== $t('Navbar.cart') ? navShopCarIcon : navShopCarIconAct
              " alt="" @click="shopCar" />
          </template>
          <span class="cur-point2" v-if="" @click="goLogin()" style="color: #555">{{$t('Navbar.login')}}</span>
          <LangSelect v-if="channelFlag" :langstr="reslang" @changelang="handleChildEvent" />
        </div>
      </div>
      <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
      <!-- <breadcrumb class="breadcrumb-container" /> -->
      <!-- <div class="right-menu">
          <template v-if="device !== 'mobile'">
            <lang-select class="right-menu-item hover-effect" />
          </template>
          <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
              <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/">
                <el-dropdown-item>
                  Home
                </el-dropdown-item>
              </router-link>
              <a target="_blank" href="https://github.com/PanJiaChen/vue-admin-template/">
                <el-dropdown-item>Github</el-dropdown-item>
              </a>
              <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
                <el-dropdown-item>Docs</el-dropdown-item>
              </a>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">Log Out</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
    </div>
    <transition name="el-zoom-in-top">
      <div class="ag-b-box" v-show="agencyType">
        <div class="agency-box row wrap">
          <div class="agency-item cur-point text-center" :class="{ active: agencyCurrent == item.id }"
            v-for="(item, index) in agencyMenuImgList" :key="index" @click="agencyChoose(item.id, item.title)">
            <div class="mb20">
              {{ item.title }}
            </div>
            <img :src="item.ossIconUrl" alt="" />
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div class="ag-b-box" v-show="healthType">
        <div class="agency-box row wrap">
          <div class="agency-item cur-point text-center" :class="{ active: healthCurrent == item.id }"
            v-for="(item, index) in healthMenuImgList" :key="index" @click="healthChoose(item.id, item.title)">
            <div class="mb10">
              {{ item.title }}
            </div>
            <img :src="item.ossPcUrl" alt="" />
          </div>
        </div>
      </div>
    </transition>
    <div class="agency-mask" v-if="agencyType || healthType" @click="cancelAgencyChange"></div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import Breadcrumb from "@/components/Breadcrumb";
  import Hamburger from "@/components/Hamburger";
  import LangSelect from "@/components/LangSelect";
  import navUserIcon from "@/assets/images/nav-user-icon.png";
  import navUserIconAct from "@/assets/images/nav-user-icon-active.png";
  import navShopCarIcon from "@/assets/images/nav-shopCar-icon.png";
  import navShopCarIconAct from "@/assets/images/nav-shopCar-icon-active.png";
  import i18n from "@/locales"; // internationalization
  export default {
    components: {
      Breadcrumb,
      Hamburger,
      LangSelect,
    },
    computed: {
      ...mapGetters(["sidebar", "avatar", "device", "sysInfo"]),
    },
    data() {
      return {
        spanrem: this.$tools.px2rem('36px'),
        selectrem: this.$tools.px2rem('660px'),
        options: [],
        optionsAll: [],
        value: "",
        reslang: '',
        userInfo: {},
        userId: '',
        userLogId: '',
        // icon
        navUserIcon,
        navUserIconAct,
        navShopCarIcon,
        navShopCarIconAct,
        activeName: this.$t('Navbar.home'),
        // 合作机构跳转框
        agencyType: false,
        agencyCurrent: undefined,
        // 健康管理跳转
        healthType: false,
        channelFlag: false,
        channelFlag2: '',
        showabroad: '',
        healthCurrent: undefined,
        // menu图片
        agencyMenuImgList: [],
        healthMenuImgList: [],
        baseUrl: process.env.VUE_APP_BASE_API,
      };
    },
    watch: {
      $route: {
        handler(route) {
          this.activeName = i18n.t(this.$route.meta.activeTitle);
        },
        immediate: true,
      },
      // channelFlag: {
      //   handler() {
      //     if (this.$store.getters.userInfo) {
      //       if (this.$store.getters.userInfo.salesmanId == '1904778899671977986') {
      //         this.channelFlag = true
      //       } else {
      //         this.channelFlag = false
      //       }
      //       console.log('有用户信息', this.channelFlag)
      //     }
      //     return this.channelFlag
      //   },
      //   immediate: true,
      // },
    },
    onUnload() {
      this.postUserLogUpdateApi();
    },
    created() {
      if (this.$route.query.channelFlag) {
        this.getHKinfoApi(this.$route.query.channelFlag)
        localStorage.setItem('channelFlag', this.$route.query.channelFlag);
      } else {}
      let show = localStorage.getItem('channelFlag');
      let salelandId = localStorage.getItem('salelandId');
      console.log('salelandId', salelandId)
      if (show == '' || show == undefined || show == null) {
        this.channelFlag = false
        if (salelandId) {
          this.channelFlag = true
        }
      } else {
        this.channelFlag = true
      }
      this.activeName = i18n.t(this.$route.meta.activeTitle);
      this.init();
      // this.getServerTypeAll();
    },
    // mounted() {
    //   if (this.$store.getters.userInfo) {
    //     console.log('有用户信息')
    //     if (this.$store.getters.userInfo.salesmanId == '1904778899671977986') {
    //       this.channelFlag = true
    //     } else {
    //       this.channelFlag = false
    //     }
    //   }
    //   console.log('this.channelFlag', this.channelFlag)
    // },
    methods: {
      goLogin() {
        this.$router.push("/login");
      },
      handleChildEvent(data) {
        let that = this
        that.activeName = i18n.t(that.$route.meta.activeTitle);
        console.log(' that.activeName ', that.activeName)
        // this.activeName = this.$route.meta.activeTitle;
        // console.log('2222', this.$route.meta.activeTitle)
      },
      changeSearch(index) {
        const {
          id,
          type
        } = this.options[index];
        this.$store.commit("app/setSearchData", {
          id,
          type
        });
        this.$router.push(`/agency/index?id=${id}&type=${type}`);
      },
      filterData(query = "") {
        const arr = this.optionsAll.filter((item) => {
          if (item.name) {
            return item.name.includes(query);
          } else {
            return false;
          }
        });
        // console.log(arr);
        if (arr.length > 50) {
          this.options = arr.slice(0, 50);
        } else {
          this.options = arr;
        }
      },
      async getServerTypeAll() {
        // 导航下拉选项
        const res = await this.$api.getServerTypeAll();
        if (res.code == 200) {
          this.optionsAll = res.data?.map(({
            id,
            navigationTitle,
            title
          }) => ({
            id,
            type: navigationTitle || "",
            name: title,
          })) ?? [];
          this.filterData();
        }
      },
      async getHKinfoApi(channel) {
        // 导航下拉选项
        const res = await this.$api.getHKinfo({
          channelFlag: channel
        });
        if (res.code == 200) {
          console.log(' this.reslang', this.reslang)
          // this.$store.getters.token = res.token
          // console.log(this.$store.getters.token, res.token)
          this.$store.commit("SET_TOKEN", res.data.token);
          this.$store.commit("SET_USER", res.data.userInfo);
          if (res.data.lang === 'yue' || res.data.lang === 'en') {
            this.$store.dispatch('app/setLanguage', 'yue')
            this.$i18n.locale = 'yue'
          } else {
            this.$store.dispatch('app/setLanguage', 'zh')
            this.$i18n.locale = 'zh'
          }
          this.$forceUpdate();
          console.log('this.$store.getters.language', this.$store.getters.language)
          //  commit("SET_SYSINFO", res.data);
          //  const user = res.data;
          //  commit("SET_USER", user);
          //  const avatar = user.userInfo.avatar == "" || user.userInfo.avatar == null ? require(
          //    "@/assets/images/profile.png") : process.env.VUE_APP_BASE_API + user.userInfo.avatar;
          //  commit("SET_NAME", user.userInfo.nickName);
          //  commit("SET_AVATAR", avatar);
        }
      },
      // 撤销合作机构选中
      cancelAgencyChange(type) {
        if (type) {
          this.activeName = this.$route.meta.activeTitle;
        }
        this.agencyType = false;
        this.healthType = false;
        this.agencyCurrent = undefined;
        this.healthCurrent = undefined;
        // this.agencyCurrent = undefined
      },
      // 初始‘
      async init() {
        let data = await this.$api.getAgencyNavigationListApi({
          parentId: '1'
        });
        if (data) {
          let a = []; // 机构
          let b = []; // 健康管理
          let arr = data.data;
          arr.sort((c, d) => Number(c.sort) - Number(d.sort));
          arr.map((item) => {
            if (item.parentId == 1) {
              a.push(item);
            } else {
              if (item.parentId == 2 || item.parentId == 4 || item.parentId == 5 || item.parentId == 6) {
                b.push(item);
              }
            }
          });
          this.agencyMenuImgList = a;
          this.healthMenuImgList = b;
        }
      },
      // 个人信息页面
      userView() {
        this.cancelAgencyChange(true);
        this.activeName = this.$t('Navbar.person');
        // this.activeName = ''
        this.$router.push("/userInfo/index");
      },
      // 购物车
      shopCar() {
        this.cancelAgencyChange(true);
        this.activeName = this.$t('Navbar.cart');
        this.$router.push("/shopCart/shopCart");
      },
      toggleSideBar() {
        this.$store.dispatch("app/toggleSideBar");
      },
      async logout() {
        await this.$store.dispatch("logout");
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      },
      // 进入首页
      goHome() {
        this.cancelAgencyChange(true);
        this.activeName = this.$t('Navbar.home');
        this.$router.push("/");
      },
      async postUserLogSaveApi(type, title) {
        let salesmanIdCache = localStorage.getItem('salelandId');
        let salesmanId = '';
        if (salesmanIdCache) {
          salesmanId = salesmanIdCache;
        }
        let IStouristID = localStorage.getItem('touristID')
        if (!this.userInfo && !IStouristID) {
          let touristID = Date.now().toString(36) + Math.random().toString(36).substr(2);
          localStorage.setItem('touristID', touristID)
        }
        if (process.env.NODE_ENV === 'production') {
          if (!title) {
            let data = {
              type: type,
              title: '',
              levelOne: '合作机构',
              levelTwo: '',
              levelThree: '',
              userId: this.userId,
              salesmanId: salesmanId,
              operUrl: '',
            }
            if (!this.userInfo) {
              data.touristId = localStorage.getItem('touristID')
            }
            let res = await this.$api.postUserLogSaveApi(data);
            if (res.code === 200) {
              this.userLogId = res.data
            }
          } else {
            let data = {
              type: type,
              title: title,
              levelOne: '合作机构',
              levelTwo: '',
              levelThree: '',
              userId: this.userId,
              salesmanId: salesmanId,
              operUrl: '',
            }
            if (!this.userInfo) {
              data.touristId = localStorage.getItem('touristID')
            }
            let res = await this.$api.postUserLogSaveApi(data);
            if (res.code === 200) {
              this.userLogId = res.data
            }
          }
        }
      },
      postUserLogUpdateApi() {
        if (process.env.NODE_ENV === 'production') {
          this.$api.postUserLogUpdateApi({
            id: this.userLogId,
          });
        }
      },
      sendinfo(title) {
        this.userInfo = JSON.parse(localStorage.getItem('userinfo'))
        if (this.userInfo && this.userInfo.userId) {
          this.userId = this.userInfo.userId;
          this.postUserLogSaveApi(1, title);
        } else {
          this.postUserLogSaveApi(3, title);
        }
      },
      handleClick() {
        console.log('this.activeName', this.activeName)
        if (this.activeName == this.$t('Navbar.home')) {
          this.cancelAgencyChange();
          this.$router.push("/");
        }
        if (this.activeName == this.$t('Navbar.parner')) {
          // this.cancelAgencyChange()
          this.sendinfo()
          this.healthType = false;
          this.healthCurrent = undefined;
          this.agencyType = !this.agencyType;
          // this.$router.push('/agency/list')
        }
        if (this.activeName == this.$t('Navbar.health')) {
          this.cancelAgencyChange()
          // this.agencyType = false;
          // this.agencyCurrent = undefined;
          // this.healthType = !this.healthType;
          this.$router.push('/healthManager/list')
        }
        // if (this.activeName == "专业保险") {
        //   this.cancelAgencyChange();
        //   this.$router.push("/insurance/index");
        // }
        if (this.activeName == this.$t('Navbar.community')) {
          this.cancelAgencyChange();
          this.$router.push("/forum/index");
        }
        if (this.activeName == this.$t('Navbar.institution')) {
          this.cancelAgencyChange();
          this.$router.push("/entered/index");
        }
        if (this.activeName == this.$t('Navbar.vip')) {
          this.cancelAgencyChange();
          this.$router.push("/interests/index");
        }
        if (this.activeName == this.$t('Navbar.form')) {
          this.cancelAgencyChange();
          this.$router.push("/scheme/index");
        }
        if (this.activeName == this.$t('Navbar.activity')) {
          this.cancelAgencyChange();
          this.$router.push("/activity/index");
        }
        // else {
        //   this.$router.push('/order_list')
        // }
      },
      // 合作机构选中
      agencyChoose(type, title) {
        this.agencyCurrent = type;
        this.sendinfo(title)
        this.$router.push({
          path: "/agency/list",
          query: {
            aType: type,
            aTitle: title,
          },
        });
        this.agencyType = false;
      },
      // 健康管理选中
      healthChoose(type, title) {
        this.healthCurrent = type;
        this.$router.push({
          path: "/healthManager/list",
          query: {
            aType: Number(type),
            aTitle: title,
          },
        });
        this.healthType = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .header-logo {
    width: 311px;
    height: 69px;
    border-radius: 4px;
  }

  ::v-deep .el-tabs__item.is-active {
    border-top-left-radius: 14px;
    background: #409eff;
    color: #fff;
  }

  ::v-deep .el-tabs__item:nth-child(2) {
    padding-left: 8px !important;
  }

  ::v-deep .el-tabs__item {
    font-size: 24px;
    font-weight: 700;
  }

  .cur-point {
    width: 80px;
    height: 80px;
  }

  @media (max-width: 480px) {
    .cur-point2 {
      font-size: 42px !important;
    }
  }

  .cur-point2 {
    font-size: 24px;
  }

  .active-btn {
    background: #ddd;
    border-radius: 14px;
    box-sizing: border-box;
    padding: 10px 11px;
  }

  .agency-mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 40, 0.08);
    position: absolute;
    z-index: 15;
  }

  @media (max-width: 480px) {
    .ag-b-box {
      position: absolute;
      // padding-left: 15vw;
      // padding-right: 15vw;
      left: 15vw;
      z-index: 100;
      width: calc(100% - 30vw);

      .agency-box {
        height: 840px !important;
        background: #fff;
        box-sizing: border-box;
        padding: 16px;
        z-index: 100;
        box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
        width: 100%;
        overflow-x: auto;

        .agency-item {
          // margin-right: 80px;
          box-sizing: border-box;
          padding: 10px;
          flex: 0 0 23%;
          margin-left: 1%;
          margin-right: 1%;

          .mb20 {
            font-size: 44px !important;
          }

          img {
            width: 15.5vw !important;
            height: 200px !important;
          }
        }

        .active {
          color: #20a3dd;
          font-weight: 700;
          background: #ecf5ff;
          border-radius: 10px;
        }
      }
    }
  }

  .ag-b-box {
    position: absolute;
    // padding-left: 15vw;
    // padding-right: 15vw;
    left: 15vw;
    z-index: 100;
    width: calc(100% - 30vw);

    .agency-box {
      height: 440px;
      background: #fff;
      box-sizing: border-box;
      padding: 30px;
      z-index: 100;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      width: 100%;
      overflow-x: auto;

      .agency-item {
        // margin-right: 80px;
        box-sizing: border-box;
        padding: 10px;
        flex: 0 0 23%;
        margin-left: 1%;
        margin-right: 1%;
        margin-bottom: 1%;

        .mb10 {
          font-size: 26px !important;
        }

        img {
          width: 11.5vw;
          height: 140px;
        }
      }

      .active {
        color: #20a3dd;
        font-weight: 700;
        background: #ecf5ff;
        border-radius: 10px;
      }
    }
  }

  .navbar {
    min-height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    padding-left: 8vw;
    padding-right: 8vw;

    .nav-item {
      position: relative;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      background: none;
    }

    ::v-deep .el-tabs__item {
      text-align: left;
    }

    ::v-deep .el-tabs__header {
      margin-bottom: 0px;
    }

    .search-box {
      ::v-deep .el-input__inner {
        border-radius: 30px;
        width: 70%;
        // height: 100px;
      }
    }

    // @media (max-width: 480px) {
    //   .search-box {
    //     width: 260px;
    //     ::v-deep .el-input__inner {
    //       border-radius: 30px;
    //       height: 100px;
    //     }
    //   }
    // }
    .mr10 {
      width: 30px;
      height: 30px;
    }

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .navbar {
      // min-height: 190px;
      // overflow: hidden;
      position: relative;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      padding-left: 6vw;
      padding-right: 6vw;

      .header-logo1 {
        width: 411px;
        height: 149px;
        border-radius: 4px;
      }

      .header-logo2 {
        width: 411px;
        height: 99px;
        border-radius: 4px;
      }

      .right-box {
        img {
          width: 60px;
          height: 60px;
        }
      }

      .nav-item {
        position: relative;
      }

      ::v-deep .el-tabs__nav-wrap {
        // width: 60vw;
      }

      ::v-deep .el-tabs__nav-wrap::after {
        background: none;
      }

      ::v-deep .el-tabs__item {
        text-align: left;
        font-size: 48px !important;
        height: 54px;
        line-height: 54px;
      }

      ::v-deep .el-tabs__header {
        margin-bottom: 0px;
      }

      .search-box {
        width: 460px;

        ::v-deep .el-input__inner {
          width: 460px;
          border-radius: 30px;
          height: 100px;
          font-size: 26px;
        }

        ::v-deep .el-select-dropdown__item {
          font-size: 26px !important;
        }
      }

      .mr10 {
        width: 30px;
        height: 30px;
      }

      .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      .breadcrumb-container {
        float: left;
      }

      .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
          outline: none;
        }

        .right-menu-item {
          display: inline-block;
          padding: 0 8px;
          height: 100%;
          font-size: 18px;
          color: #5a5e66;
          vertical-align: text-bottom;

          &.hover-effect {
            cursor: pointer;
            transition: background 0.3s;

            &:hover {
              background: rgba(0, 0, 0, 0.025);
            }
          }
        }

        .avatar-container {
          margin-right: 30px;

          .avatar-wrapper {
            margin-top: 5px;
            position: relative;

            .user-avatar {
              cursor: pointer;
              width: 40px;
              height: 40px;
              border-radius: 10px;
            }

            .el-icon-caret-bottom {
              cursor: pointer;
              position: absolute;
              right: -20px;
              top: 25px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
</style>
<style>
  .search-box {
    width: 460px;

    ::v-deep .el-input__inner {
      width: 460px !important;
      border-radius: 30px;
      height: 100px;
    }

    .el-select-dropdown__item {
      font-size: 28px !important;
    }
  }

  .el-dropdown {
    font-size: 30px !important;
  }

  .el-dropdown-menu__item {
    font-size: 30px !important;
  }
</style>